import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { propArrayShape } from '../../../../../helpers/custom-prop-types';
const AboutContentsTheme = (props) => {
    const { middleTasks } = props;
    return (_jsx("section", { children: _jsxs("div", Object.assign({ className: 'about-box is-free' }, { children: [_jsx("h2", Object.assign({ className: 'about-title' }, { children: "PROFESSIONAL THEME" })), _jsx("ul", Object.assign({ className: 'themeList' }, { children: middleTasks.map((middleTask) => (_jsx("li", { children: middleTask.name }, middleTask.id))) }))] })) }));
};
AboutContentsTheme.propTypes = {
    middleTasks: propArrayShape().isRequired,
};
export default AboutContentsTheme;
